import React from "react";
import type { Notifications } from "./WatcherFormNotifications";
import ApiCall from "../auth/ApiCall";
import buttonBackground from "../assets/button_background_blue.webp";

interface Rule {
  [key: string]: unknown;
}

interface PutUserRuleProps {
  ruleId?: string;
  formState: number;
  setFormState: (state: number) => void;
  sport: string;
  sportId: string | number;
  name: string;
  rule_type: number;
  teams: string[];
  books: string[];
  rule: Rule;
  notifications: Notifications;
}

interface UpdateRuleData {
  id?: string;
  sport: string;
  sportId: string | number;
  name: string;
  rule_type: number;
  teams: string[];
  books: string[];
  rule: Rule;
  notifications: Notifications;
}

const PutUserRule: React.FC<PutUserRuleProps> = ({
  ruleId,
  formState,
  setFormState,
  sport,
  sportId,
  name,
  rule_type,
  teams,
  books,
  rule,
  notifications,
}) => {
  const handleUpdate = async () => {
    const jsonData: UpdateRuleData = {
      id: ruleId,
      sport: sport,
      sportId: sportId,
      name: name,
      rule_type: rule_type,
      teams: teams,
      books: books,
      rule: rule,
      notifications: notifications,
    };
    ApiCall.makeAuthenticatedRequest("/api/update_rule/", {
      method: "PUT",
      body: JSON.stringify(jsonData),
    });
    // For now, just move to next form state
    setFormState(formState + 1);
  };

  return (
    <button
      className="my-form-button button-base button-3d font_family_base"
      style={{
        marginTop: "5px",
        marginBottom: "5px",
        backgroundImage: `url(${buttonBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        fontWeight: 700,
      }}
      onClick={handleUpdate}
    >
      Update
    </button>
  );
};

export default PutUserRule;
